import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import * as _ from "lodash";
import { AppSessionService } from "../app-session/app-session.service";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import {
  setSimpleFilterQuery,
  setAdvancedFilterQuery,
} from "../../utils/tableUtils";
import { GridUtils } from "../../utils/gridUtils";

const EMPTY_STRING = "";
@Injectable({
  providedIn: "root",
})
export class PromptService {
  public remoteData: BehaviorSubject<any[]>;
  private BASE_URL = this.appSession.baseUrl + "/api/v1/prompts";

  constructor(private http: HttpClient, private appSession: AppSessionService) {
    this.remoteData = new BehaviorSubject([]);
  }

  getPrompts(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }
    return this.http.get(
      this.buildDataUrl(
        paging,
        filteringArgs,
        sortingArgs,
        headers,
        "/search?"
      ),
      { headers }
    );
  }

  getPrompt(code): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.appSession.baseUrl + "/api/v1/prompts"}/${code}`;
    return this.http.get(url, { headers });
  }

  getDataTypePrompts(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Content-type",
      "application/x-www-form-urlencoded; "
    );

    if (pageReq && pageReq.query && (pageReq.query as string).length > 0) {
      headers = headers.set("query", pageReq.query);
    }

    const url = `${this.appSession.baseUrl + "/api/v1/prompts"}/dataTypes`;
    if (!pageReq) {
      // pageReq not defined
      pageReq = {
        offset: 0,
        limit: 40,
        realSize: false,
      };
    }

    return this.http.get(url, { headers });
  }

  createPrompts(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(action.prompt);
    const url = `${this.appSession.baseUrl + "/api/v1/prompts"}`;
    return this.http.post(url, data, { headers });
  }

  updatePrompts(prompt): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(prompt);
    const url = `${this.appSession.baseUrl + "/api/v1/prompts"}/${
      prompt?.code
    }`;
    return this.http.put(url, data, { headers });
  }

  deletePrompt(data): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const url =
      `${this.appSession.baseUrl + "/api/v1/prompts"}/` +
      encodeURIComponent(data.data.code);
    return this.http.delete(url, { headers });
  }

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/prompts"
    }${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }
}
